import { Component, ViewChild } from '@angular/core';
import { ActiveEmployeeModel, AppTableComponent,  MessagesComponent, SearchModel, SearchResultModel, TranslationManager, UsersService } from 'src/common';
import { OrganizationalUnitModel, OrganizationalUnitService } from 'src/common/services/organizational-unit';


@Component({
  selector: 'organizational-unit-select',
  templateUrl: 'organizational-unit-select.component.html'
})

export class OrganizationalUnitSelectComponent {
  constructor(private service: OrganizationalUnitService) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedId: number;
  items: any[];
  show: boolean = false;
  resolve: any;

  requestId:number;
  cond:string;

  showModal() : Promise<OrganizationalUnitModel> {
      this.show = true;

      this.table.onSearch = this.doSearch.bind(this);
      this.table.search();

      return new Promise((resolve) => {
          this.resolve = resolve;
      })
  }

  doSearch(search: SearchModel) {
      this.service.search(search).then((result: SearchResultModel<OrganizationalUnitModel>) => {
        this.items = result.items;
        this.table.setTotalCount(result.totalCount);
    });
  }

  selectOrganizationalUnit(id: number,event) {
      if (event.target.checked) {
        this.selectedId = id;
      }
      else {
        this.selectedId = undefined;
      }
  }

  close() {
      this.show = false;
      if (this.resolve) {
          this.resolve();
      }
  }

  submit() {
    if (this.selectedId == undefined) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате изабрати задатак')]);
    }
    else {
      this.save();
    }
  }

  save() {

      this.show = false;
      if (this.resolve) {
          let model: OrganizationalUnitModel = this.items.find((x => x.id == this.selectedId));
          this.resolve(model);
      }
  }
}
